export function scrollWindowToTop(target = window) {
  const root = target.document?.documentElement;
  const previousScrollBehavior = root?.style.scrollBehavior;

  if (root) root.style.scrollBehavior = "auto";
  target.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });
  if (root) root.style.scrollBehavior = previousScrollBehavior;
}
